<template>
  <main class="layout--default">
    <NuxtLoadingIndicator color="#bf3bd9" />
    <slot />
    <UModals />
  </main>
</template>

<script setup>
  const isPreview = useRuntimeConfig().public.CMS_ENV !== "production";

  const version = isPreview ? "draft" : "published";

  const { story, error } = await useAsyncStoryblok("data/config", { api: { version } });

  if (error.value) {
    throw createError({
      statusCode: error.value.statusCode,
      statusMessage: error.value.statusMessage,
    });
  }

  const config = computed(() => story.value.content);
</script>
